import { LogoDatabricksIcon, LogoGlueIcon } from '@prophecy/ui-v3/Icons';
import React from 'react';

import { BackEndCodeLanguage, Connector, ConnectorType } from '../../graphqlTypes/enums';
import { FabricProviderType } from './types';

type SVGIcon = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
>;

export const ConnectionIcons: { [K in ConnectorType]: SVGIcon } = {
  [Connector.DatabricksConnectorType]: LogoDatabricksIcon,
  [Connector.GlueConnectorType]: LogoGlueIcon
};

export const ConnectionLabels: { [K in ConnectorType]: string } = {
  [Connector.DatabricksConnectorType]: 'Databricks Connector',
  [Connector.GlueConnectorType]: 'Glue Connector'
};

/** DOM id / `fieldToFocus` query value for scrolling to the Databricks cluster control in fabric UIs. */
export const DATABRICKS_CLUSTER_SELECTOR_ID = 'databricksClusterSelector';

// UPDATE THIS VALUE WHENEVER BE UPDATES ORCHESTRATION FABRIC TOKEN EXPIRY TIME
// expiry time is 24 hours, we subtract 1 hour to avoid any potential issues with the token expiry
export const FABRIC_TOKEN_STALE_TIME = 1000 * 60 * 60 * 23; // 23 hours

// Use these options for token queries to avoid mount/focus triggered refetches.
// staleTime matching refetchInterval ensures cached tokens are never considered stale
// between polling cycles, so mounts always get the cached value without triggering a refetch.
export const FABRIC_TOKEN_QUERY_OPTIONS = {
  staleTime: FABRIC_TOKEN_STALE_TIME,
  refetchInterval: FABRIC_TOKEN_STALE_TIME,
  refetchIntervalInBackground: true
} as const;

export const LanguageToProviderTypeMap = {
  [BackEndCodeLanguage.sql]: [FabricProviderType.SQL, FabricProviderType.Airflow, FabricProviderType.Orchestration],
  [BackEndCodeLanguage.python]: [FabricProviderType.Spark, FabricProviderType.Airflow, FabricProviderType.DataQuality],
  [BackEndCodeLanguage.scala]: [FabricProviderType.Spark, FabricProviderType.Airflow, FabricProviderType.DataQuality]
};
